import { combineReducers } from "redux";
import { all, fork } from "redux-saga/effects";
import { routerReducer } from "react-router-redux";
import authReducer from "./auth/reducers";
import { saga as authSaga } from "./auth";
import areaReducer from "./auth/areaReducer";
import cityReducer from "./auth/cityReducer";
import selectedTestReducer from "./auth/selectedTestReducer";
import cartReducer from "./cart/CartReducer";
import savedAddressReducer from "./savedaddress/SavedAddressReducer";
import addressReducer from "./deliveryAddress/addressReducer";
import labPackageReducer from './labpackage/LabPackageReducer'
import { saga as cartSaga } from './cart'
import { saga as savedAddressSaga } from './savedaddress'
import { saga as labPackageSaga } from './labpackage';

export function* rootSaga() {
  yield all([fork(authSaga), fork(cartSaga), fork(savedAddressSaga), fork(labPackageSaga)]);
}

export const rootReducer = combineReducers({
  auth: authReducer,
  router: routerReducer,
  area: areaReducer,
  city: cityReducer,
  selected_test: selectedTestReducer,
  cartsData: cartReducer,
  selectedAddressData: addressReducer,
  savedAddressReducers: savedAddressReducer,
  labPackageReducer: labPackageReducer
});

export default rootReducer;
